module.exports = __webpack_public_path__ + "static/media/chat-app.aeadfa95.png";